import { CryptoNetDictionaryResponse } from '@acme/api';
import { useEffect, useState } from 'react';
import { netStore } from './model';

export const useNet = (netId?: string) => {
  const [net, setNet] = useState<CryptoNetDictionaryResponse | undefined>();
  const [nets, setNets] = useState<CryptoNetDictionaryResponse[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  useEffect(() => {
    const loadCountry = async () => {
      try {
        setIsLoading(true);
        const nets = await netStore.getNets();
        setNets(nets);

        if (netId) {
          const foundCountry = nets.find((c) => c.id === Number(netId));
          setNet(foundCountry);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error('Failed to load country')
        );
      } finally {
        setIsLoading(false);
      }
    };

    loadCountry();
  }, [netId]);

  return { net, nets, isLoading, error };
};
